import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';

const CertificationPageHero = ({ image, title, subtitle, children, overlay }) => {
  const overlayValue =
    overlay || 'linear-gradient(120deg, rgba(17,17,17,0.7) 0%, rgba(0,0,0,0.5) 45%, rgba(17,17,17,0.85) 100%)';

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: { xs: 0 },
        height: { xs: 240, md: 300 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        mb: { xs: 3, md: 4 },
        bgcolor: '#0d0d0d',
      }}>
      {image ? (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            filter: 'brightness(0.9)',
          }}
        />
      ) : null}
      <Box sx={{ position: 'absolute', inset: 0, background: overlayValue }} />

      <Stack
        spacing={1.75}
        sx={{
          position: 'relative',
          zIndex: 1,
          p: { xs: 3, md: 5 },
          maxWidth: 960,
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}>
        {title ? (
          <Typography
            variant="h1"
            sx={{
              fontWeight: 900,
              lineHeight: 1.05,
              textShadow: '0 14px 36px rgba(0,0,0,0.55)',
              color: '#ffffff',
              fontSize: { xs: 38, sm: 46, md: 56, lg: 64 },
            }}>
            {title}
          </Typography>
        ) : null}
        {subtitle ? (
          <Typography
            variant="h5"
            sx={{
              maxWidth: 820,
              fontSize: { xs: 18, sm: 20, md: 22 },
              fontWeight: 800,
              textShadow: '0 10px 28px rgba(0,0,0,0.45)',
            }}>
            {subtitle}
          </Typography>
        ) : null}
        {children}
      </Stack>
    </Box>
  );
};

CertificationPageHero.propTypes = {
  image: PropTypes.string,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  height: PropTypes.number,
  overlay: PropTypes.string,
};

export default CertificationPageHero;
